const API_BASE_URL = process.env.REACT_APP_API_URL || "https://aintreel.site";

export default API_BASE_URL;